import { Routes, Route } from "react-router-dom";
import Home from "./components/Home";
import Login from "./components/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import { UserAuthContextProvider } from "./context/UserAuthContext";
import Landing from "./components/Landing";
import ForgotPassword from "./components/ForgotPassword";
import PersonalInformation from "./components/PersonalInformation";
import ChangePassword from "./components/ChangePassword";
import Classes from "./components/Classes";
import Sessions from "./components/Sessions";
import Terms from "./components/Terms";
import Sections from "./components/Sections";
import Subjects from "./components/Subjects";
import Students from "./components/Students";
import Teachers from "./components/Teachers";
import Parents from "./components/Parents";
import ClassDetailsPage from './components/ClassDetailsPage';
import Archives from './components/Archives';
import ArchiveSessions from './components/ArchiveSessions';
import ArchiveTerms from './components/ArchiveTerms';
import ArchiveClasses from './components/ArchiveClasses';
import ClassResults from './components/ClassResults';
import SubjectScores from "./components/SubjectScores";
import PsychomotorSkills from "./components/PsychomotorSkills";
import Attendance from "./components/Attendance";
import Timetable from "./components/Timetable";
import AttendanceIndividual from "./components/AttendanceIndividual";
import ClassResultsIndividual from "./components/ClassResultsIndividual";
import { DashboardProvider } from "./context/DashboardContext";
import { ManagementProvider } from "./context/ManagementContext";

function App() {
  return (
    <>
      <UserAuthContextProvider>
        <DashboardProvider>
          <ManagementProvider>
            <Routes>              
              <Route
                path="/home"
                element={<ProtectedRoute><Home /></ProtectedRoute>}
              />
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/personal-information" element={<ProtectedRoute><PersonalInformation /></ProtectedRoute>} />
              <Route path="/change-password" element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} />
              <Route path="/classes" element={<ProtectedRoute><Classes/></ProtectedRoute>} />
              <Route path="/classes/:id" element={<ProtectedRoute><ClassDetailsPage /></ProtectedRoute>} />
              <Route path="/sessions" element={<ProtectedRoute><Sessions/></ProtectedRoute>} />
              <Route path="/terms" element={<ProtectedRoute><Terms/></ProtectedRoute>} />

              <Route path="/sections" element={<ProtectedRoute><Sections/></ProtectedRoute>} />
              <Route path="/subjects" element={<ProtectedRoute><Subjects/></ProtectedRoute>} />
              <Route path="/students" element={<ProtectedRoute><Students/></ProtectedRoute>} />
              <Route path="/teachers" element={<ProtectedRoute><Teachers/></ProtectedRoute>} />
              <Route path="/parents" element={<ProtectedRoute><Parents/></ProtectedRoute>} />
              <Route path="/timetable" element={<ProtectedRoute><Timetable/></ProtectedRoute>} />

              <Route path="/archives" element={<ProtectedRoute><Archives /></ProtectedRoute>} />
              <Route path="/archives/:sectionId" element={<ProtectedRoute><ArchiveSessions /></ProtectedRoute>} />
              <Route path="/archives/:sectionId/:sessionId" element={<ProtectedRoute><ArchiveTerms /></ProtectedRoute>} />
              <Route path="/archives/:sectionId/:sessionId/:termId" element={<ProtectedRoute><ArchiveClasses /></ProtectedRoute>} />
              <Route path="/archives/:sectionId/:sessionId/:termId/:classId" element={<ProtectedRoute><ClassResults /></ProtectedRoute>} />
              <Route path="/results/:sectionId/:sessionId/:termId/:classId/:kidId" element={<ProtectedRoute><ClassResultsIndividual /></ProtectedRoute>} />
              <Route path="/scores/:classId/:subjectId" element={<ProtectedRoute><SubjectScores /></ProtectedRoute>} />
              <Route path="/psychomotor/:classId" element={<ProtectedRoute><PsychomotorSkills /></ProtectedRoute>} />
              <Route path="/attendance/:classId" element={<ProtectedRoute><Attendance /></ProtectedRoute>} />
              <Route path="/attendance/:classId/:kidId" element={<ProtectedRoute><AttendanceIndividual /></ProtectedRoute>} />
            </Routes>
          </ManagementProvider>
        </DashboardProvider>
      </UserAuthContextProvider>
    </>
  );
}

export default App;